import { Component, ChangeDetectionStrategy, Inject, Input, NgModule } from '@angular/core';
import { DOCUMENT, CommonModule } from '@angular/common';
import { AwComponent } from '@aw/ads-components/aw-parent';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function AwProgressBarComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.type)("ngStyle", ctx_r0.currentProgress);
} }
function AwProgressBarComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("Loading ", ctx_r1.progress, "%");
} }
const _c0 = ["*"];
class AwProgressBarComponent extends AwComponent {
    constructor(document) {
        super();
        this.document = document;
        this.type = 'determinate';
        this.role = 'progressbar';
        this.ariaValuemin = 0;
        this.ariaValuemax = 100;
        this.tabindex = -1;
        this.progressStepperClasses = '';
        this.setFocusToProgressByChangeValue = true;
        this._progress = 0;
    }
    get progress() {
        return this._progress;
    }
    set progress(value) {
        this._progress = typeof value === 'string' ? parseInt(value, 10) : value;
        if (value) {
            this.focusToProgressByChangeValue();
        }
    }
    get currentProgress() {
        return this.progress === undefined ? null : { width: `${this.progress}%` };
    }
    get classes() {
        return `${this.styleClasses || ''} ${this.progressStepperClasses}`;
    }
    focusToProgressByChangeValue() {
        if (this.setFocusToProgressByChangeValue) {
            const progress = this.document.querySelector('.progress');
            progress.focus();
        }
    }
}
AwProgressBarComponent.ɵfac = function AwProgressBarComponent_Factory(t) { return new (t || AwProgressBarComponent)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
AwProgressBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AwProgressBarComponent, selectors: [["aw-progress-bar"]], inputs: { type: "type", role: ["data-role", "role"], ariaValuemin: ["data-aria-valuemin", "ariaValuemin"], ariaValuemax: ["data-aria-valuemax", "ariaValuemax"], tabindex: ["data-tabindex", "tabindex"], progressStepperClasses: "progressStepperClasses", setFocusToProgressByChangeValue: "setFocusToProgressByChangeValue", progress: "progress", elementId: "elementId", styleClasses: "styleClasses", ariaBusy: ["data-aria-busy", "ariaBusy"], ariaLive: ["data-aria-live", "ariaLive"], ariaLabel: ["data-aria-label", "ariaLabel"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0, decls: 4, vars: 13, consts: [[1, "progress", 3, "ngClass"], ["automation", "currentProgress", "class", "primary", 3, "ngClass", "ngStyle", 4, "ngIf"], ["class", "visuallyhidden", 4, "ngIf"], ["automation", "currentProgress", 1, "primary", 3, "ngClass", "ngStyle"], [1, "visuallyhidden"]], template: function AwProgressBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, AwProgressBarComponent_div_1_Template, 1, 2, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵtemplate(3, AwProgressBarComponent_span_3_Template, 2, 1, "span", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.classes);
        ɵngcc0.ɵɵattribute("id", ctx.elementId)("automation", ctx.automationValue || "progressBarComponent")("role", ctx.role)("aria-busy", ctx.role === "progressbar" ? null : ctx.ariaBusy)("aria-live", ctx.role === "progressbar" ? null : ctx.ariaLive)("aria-label", ctx.ariaLabel || ctx.type + " progress bar")("aria-valuemin", ctx.ariaValuemin)("aria-valuemax", ctx.ariaValuemax)("aria-valuenow", ctx.type === "indeterminate" ? null : ctx.progress)("tabindex", ctx.tabindex);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "indeterminate" || ctx.progress > 0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "determinate");
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgStyle], encapsulation: 2, changeDetection: 0 });
AwProgressBarComponent.selectorDowngrade = 'aw-progress-bar';
AwProgressBarComponent.ctorParameters = () => [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
AwProgressBarComponent.propDecorators = {
    elementId: [{ type: Input }],
    progress: [{ type: Input, args: ['progress',] }],
    styleClasses: [{ type: Input }],
    type: [{ type: Input }],
    role: [{ type: Input, args: ['data-role',] }],
    ariaBusy: [{ type: Input, args: ['data-aria-busy',] }],
    ariaLive: [{ type: Input, args: ['data-aria-live',] }],
    ariaLabel: [{ type: Input, args: ['data-aria-label',] }],
    ariaValuemin: [{ type: Input, args: ['data-aria-valuemin',] }],
    ariaValuemax: [{ type: Input, args: ['data-aria-valuemax',] }],
    tabindex: [{ type: Input, args: ['data-tabindex',] }],
    progressStepperClasses: [{ type: Input }],
    setFocusToProgressByChangeValue: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwProgressBarComponent, [{
        type: Component,
        args: [{
                selector: 'aw-progress-bar',
                template: "<div\n    class=\"progress\"\n    [attr.id]=\"elementId\"\n    [attr.automation]=\"automationValue || 'progressBarComponent'\"\n    [ngClass]=\"classes\"\n    [attr.role]=\"role\"\n    [attr.aria-busy]=\"role === 'progressbar' ? null : ariaBusy\"\n    [attr.aria-live]=\"role === 'progressbar' ? null : ariaLive\"\n    [attr.aria-label]=\"ariaLabel || type + ' progress bar'\"\n    [attr.aria-valuemin]=\"ariaValuemin\"\n    [attr.aria-valuemax]=\"ariaValuemax\"\n    [attr.aria-valuenow]=\"type === 'indeterminate' ? null : progress\"\n    [attr.tabindex]=\"tabindex\"\n>\n    <div\n        automation=\"currentProgress\"\n        class=\"primary\"\n        *ngIf=\"type === 'indeterminate' || progress > 0\"\n        [ngClass]=\"type\"\n        [ngStyle]=\"currentProgress\">\n    </div>\n    <ng-content></ng-content>\n    <span *ngIf=\"type === 'determinate'\" class=\"visuallyhidden\">Loading {{progress}}%</span>\n</div>",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { type: [{
            type: Input
        }], role: [{
            type: Input,
            args: ['data-role']
        }], ariaValuemin: [{
            type: Input,
            args: ['data-aria-valuemin']
        }], ariaValuemax: [{
            type: Input,
            args: ['data-aria-valuemax']
        }], tabindex: [{
            type: Input,
            args: ['data-tabindex']
        }], progressStepperClasses: [{
            type: Input
        }], setFocusToProgressByChangeValue: [{
            type: Input
        }], progress: [{
            type: Input,
            args: ['progress']
        }], elementId: [{
            type: Input
        }], styleClasses: [{
            type: Input
        }], ariaBusy: [{
            type: Input,
            args: ['data-aria-busy']
        }], ariaLive: [{
            type: Input,
            args: ['data-aria-live']
        }], ariaLabel: [{
            type: Input,
            args: ['data-aria-label']
        }] }); })();

class AwProgressBarModule {
}
AwProgressBarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AwProgressBarModule });
AwProgressBarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AwProgressBarModule_Factory(t) { return new (t || AwProgressBarModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AwProgressBarModule, { declarations: function () { return [AwProgressBarComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AwProgressBarComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwProgressBarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    AwProgressBarComponent
                ],
                exports: [
                    AwProgressBarComponent
                ]
            }]
    }], null, null); })();

export { AwProgressBarComponent, AwProgressBarModule };

//# sourceMappingURL=aw-ads-components-aw-progress-bar.js.map